import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { received_gifts_list, delete_requests, delete_draft } from './api';

const initialState = {
  receivedGiftsLoading: false,
  getAllApproverLoading: false,
  receivedGiftsList: [],
  CountsReceivedGiftsList: {},
  pagination: []
};

const actions = {
  GET_RECEIVED_GIFT_LIST: 'getReceivedGiftsList/GET_RECEIVED_GIFT_LIST',
  DELETE_REQUEST: 'deleteRequest/DELETE_REQUEST',
  //SEARCH_TICKET: 'searchvalues/SEARCH_TICKET',
  DELETE_DRAFT: 'deleteDraft/DELETE_DRAFT'
};

export const getReceivedGiftsList = createAsyncThunk(
  actions.GET_RECEIVED_GIFT_LIST,
  async (payload) => {
    const response = await received_gifts_list(payload);
    return response;
  }
);

export const deleteRequest = createAsyncThunk(
  actions.DELETE_REQUEST,
  async (payload) => {
    const response = await delete_requests(
      `delete/gatepass?gpid=${payload.gpid}`,
      payload
    );
    return response;
  }
);

export const deleteDraft = createAsyncThunk(
  actions.DELETE_DRAFT,
  async (payload) => {
    const response = await delete_draft(
      `draft?draft_id=${payload.gpid}`,
      payload
    );
    return response;
  }
);

/* export const searchvalues = createAsyncThunk(
  actions.SEARCH_TICKET,
  async (payload) => {
    const response = await requests(
      `gatepass?status=${payload?.status}&search=${payload?.ticket}&page=${payload?.page}`
    );
    return response;
  }
); */

export const receivedGiftsListSlice = createSlice({
  name: 'receivedGifts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReceivedGiftsList.pending, (state) => {
        state.receivedGiftsLoading = true;
      })
      .addCase(getReceivedGiftsList.fulfilled, (state, action) => {
        const { counts, data, pagination } = action.payload;
        state.receivedGiftsLoading = false;
        state.receivedGiftsList = data ? data : [];
        state.CountsReceivedGiftsList = counts ? counts : {};

        state.pagination = pagination || null;
      })
      .addCase(getReceivedGiftsList.rejected, (state) => {
        state.receivedGiftsLoading = false;
      });

    builder
      .addCase(deleteRequest.pending, (state) => {
        state.getAllApproverLoading = true;
      })
      .addCase(deleteRequest.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.getAllApproverLoading = false;
        if (!success) {
          message.error(msg);
        } else {
          message.success('record deleted successfully');
        }
      })
      .addCase(deleteRequest.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllApproverLoading = false;

        message.error(msg);
      });
    builder
      .addCase(deleteDraft.pending, (state) => {
        state.getAllApproverLoading = true;
      })
      .addCase(deleteDraft.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.getAllApproverLoading = false;
        if (!success) {
          message.error(msg);
        } else {
          message.success('record deleted successfully');
        }
      })
      .addCase(deleteDraft.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.getAllApproverLoading = false;

        message.error(msg);
      });
    /* builder
      .addCase(searchvalues.pending, (state) => {
        state.getAllApproverLoading = true;
      })
      .addCase(searchvalues.fulfilled, (state, action) => {
        const { success, data, pagination } = action.payload;
        state.getAllApproverLoading = false;
        state.allRequests = data ? data : [];
        state.pagination = pagination || null;

        if (!success) {
          // message.error(msg);
        }
      })
      .addCase(searchvalues.rejected, (state) => {
        // const { message: msg } = action.error;

        state.getAllApproverLoading = false;

        // message.error(msg);
      }); */
  }
});
export default receivedGiftsListSlice.reducer;
